import { Link as MuiLink } from '@mui/material';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

const Link = ({ children, ...props }: LinkProps) => {
  return (
    <MuiLink component={RouterLink} {...props}>
      {children}
    </MuiLink>
  );
};

export default Link;
